import { fetch } from '../../api';
import { fetchFeed } from './general';

export default (from) => {
  const feed = { id: 'notifications', dataType: 'notifications' };

  const fetchData = async function fetchData() {
    const { payload } = await fetch(
      'notifications/items',
      { query: { markRead: true, from: 0, size: 50 } }
    );

    const { groups, users, notifications, unread } = payload;

    notifications.forEach(n => {
      const post = n.post || {};
      if (post.superParent) {
        post.superParent.group = post.group;
        post.superParent.groupId = post.groupId;
      }
    });
    notifications.slice(0, unread.unread).forEach(n => n.unread = true);
    notifications.slice(unread.unread).forEach(n => n.unread = false);

    return {
      data: { groups, users, notifications },
      unread: { notifications: 0 },
    };
  };

  return fetchFeed(feed, from === 0, fetchData);
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/notification.js